<header>
    <div [innerHTML]="title"></div>
</header>
